import { Component, OnInit, NgZone } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { WindowRefService } from '../../services/window-ref.service';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
declare var $: any;
@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.scss']
})
export class UpgradeComponent implements OnInit {

  isLoading = true;

  loggedInUserDetails;

  isTypeOne = false;

  recurring_type = 1; // monthly = 1;annually = 2;

  groupName = '';
  isGroupRow;

  isMobile;
  isViewAllEnabled = true;

  apiResponse;

  annualSubscriptionNotAllowed;

  // Type-2 Specific Flags
  activePlanName;
  upgradeTypeTwoButtonClicked = false;
  planDataToSend;
  modalRefToSend;
  flagToTriggerChangeEvent = 0;

  constructor(private zone: NgZone, private dashboardService: DashboardService, private windowRef: WindowRefService) {
    // subscribe to subscription change request flag
    this.dashboardService.getPlanChangeRequestFlag().subscribe(data => {
      console.log('get flag', data);
      this.apiResponse.plan_change_or_cancellation_request = data;
    });
  }

  ngOnInit() {

    this.loggedInUserDetails = this.dashboardService.decodeToken();

    if (window.innerWidth <= 576) {
      this.isMobile = true;
    }
    else {
      this.isMobile = false;
    }

    this.getSubscriptionData();

  }

  // get Data
  getSubscriptionData() {
    this.isLoading = true;

    const postData = {
      recurring_type: this.recurring_type
    };
    if (this.recurring_type == 2) {
      this.annualSubscriptionNotAllowed = true;
    }
    else {
      this.annualSubscriptionNotAllowed = false;
    }
    // if (this.annualSubscriptionNotAllowed == true) {
    //   this.annualSubscriptionNotAllowed = false;
    // }

    this.dashboardService.getSubscriptionDetails(postData).subscribe(response => {
      this.isLoading = false;

      this.apiResponse = response.data;

      if (response.statusCode == 200 && response.status == true) {
        this.zone.run(() => {
          this.isTypeOne = (response.data.subscription_status == 1) ? false : true;
        });

        if (this.isTypeOne == false) {
          (response.data.plan).forEach(element => {
            if (element.activePlan == true) {
              this.zone.run(() => {
                this.activePlanName = element.plan;
              });
            }
          });
        }
        if (this.isTypeOne == true) {
          if (window.innerWidth <= 576) {

            const plans = response.data.plans;
            const amenities = response.data.amenities;

            for (let i = 0; i < plans.length; i++) {


              plans[i].feature = {};
              let temp;
              for (let j = 0; j < amenities.length; j++) {
                // amenities.forEach(function (amenity) {

                // plan.amenities.group = [];

                !plans[i].feature.hasOwnProperty(amenities[j].group) ? plans[i].feature[amenities[j].group] = [] : '';

                if (plans[i].plan_type === 1) {
                  // console.log(plan);
                  if (amenities[j].enterprise !== null && plans[i].feature.hasOwnProperty(amenities[j].group)) {
                    // console.log(amenity.amenities)
                    plans[i].feature[amenities[j].group].push(amenities[j].amenities);

                  }

                } else if (plans[i].plan_type === 2) {

                  if (amenities[j].professional !== null && plans[i].feature.hasOwnProperty(amenities[j].group)) {
                    plans[i].feature[amenities[j].group].push(amenities[j].amenities);
                  }

                } else if (plans[i].plan_type === 3) {
                  if (amenities[j].starter !== null && plans[i].feature.hasOwnProperty(amenities[j].group)) {
                    plans[i].feature[amenities[j].group].push(amenities[j].amenities);
                  }
                }

              }

            }
            console.log(plans)
            this.apiResponse = plans;
          }
        }
      }
    });
  }


  // populate the lower table data, implemented for the group-title row (coloured row)
  populateTable(group) {
    if (group != this.groupName) {
      this.isGroupRow = true;
      this.groupName = group;
    }
    else {
      this.isGroupRow = false;
    }
  }


  // Type -1 Mobile : 'Show Features' link visibility
  setShowFeaturesVisibility(event) {
    document.getElementById(event.id).classList.toggle('d-none');
  }

  //
  upgradeTypeOneSubscribeAction(planData) {

    console.log(planData);

    // As for now, no annual subscription
    if (this.recurring_type == 2) {
      this.annualSubscriptionNotAllowed = true;
      window.scrollTo(0, 0);
    }
    else {
      const createSubscriptionPostData = {
        plan: planData.plan_type,
        type: this.recurring_type
      }

      this.dashboardService.createSubscription(createSubscriptionPostData).subscribe(response => {
        this.isLoading = false;
        if (response.statusCode == 200 && response.status == true) {
          const options = {
            key: environment.razorpay_key,
            subscription_id: response.data.subscription_id,
            subscription_card_change: 0,
            name: 'Mindler',
            description: response.data.description,
            image: '/your_logo.png',
            prefill: { name: response.data.name, email: response.data.email },
            theme: { color: '#007fb6' },
            handler: ((razorpayResponse) => {
              console.log('razorResponse', razorpayResponse);
              const createSubscriptionPostData = {
                plan: planData.plan_type,
                type: this.recurring_type,
                razorpay_payment_id: razorpayResponse.razorpay_payment_id,
                razorpay_subscription_id: razorpayResponse.razorpay_subscription_id,
                razorpay_signature: razorpayResponse.razorpay_signature
              };
              this.dashboardService.razorpayAuthDetails(createSubscriptionPostData).subscribe(response => {
                if (response.statusCode == 200 && response.status == true) {
                  this.getSubscriptionData();
                }
              });
            })

          };
          const rzp1 = new this.windowRef.nativeWindow.Razorpay(options);
          rzp1.open();
        }
      });
    }
  }

  // Type-2 specific
  setViewAllFlag() {
    this.isViewAllEnabled = !this.isViewAllEnabled;
  }


  upgradeTypeTwoAction(data, modalRef) {
    this.upgradeTypeTwoButtonClicked = true;
    this.flagToTriggerChangeEvent = this.flagToTriggerChangeEvent + 1;
    this.planDataToSend = data;
    this.modalRefToSend = modalRef;

    //this.dashboardService.planActions(data, modalRef);

    //console.log(data);

    // if (data.action === 'Upgrade') {
    //   // console.log('upgrade');
    // }
    // else if (data.action === 'Cancel Renewal') {
    //   // console.log('cancel');
    // }
    // else if (data.action === 'Downgrade') {
    //   // console.log('down');
    //   if (true) {
    //     $('#' + modalRef.id).modal('show');
    //   }
    // }
  }

}
